import * as Yup from 'yup';

const commonValidation = {
  accountId: Yup.string().required('Debes seleccionar una cuenta'),
  coverAmount: Yup.string().nullable(),
  estimatedNetCommission: Yup.string().nullable(),
  estimatedNetPrime: Yup.string().nullable(),
  insuranceCategoryId: Yup.string().required('Debes seleccionar un ramo'),
  quotationRequestFile: Yup.mixed().nullable(),
  subjectMatter: Yup.string().required('Debes ingresar una materia'),
  subjectMatterAddress: Yup.string().nullable(),
  validityStart: Yup.string().nullable()
};

const requestQuotationValidation = {
  ...commonValidation,
  beneficiaryPersonAddress: Yup.string().when('beneficiaryPersonName', {
    is: val => !!val,
    then: Yup.string().required('Debes ingresar dirección de beneficiario'),
    otherwise: Yup.string().nullable()
  }),
  beneficiaryPersonName: Yup.string().nullable(),
  beneficiaryPersonNationalIdentification: Yup.string().when('beneficiaryPersonName', {
    is: val => !!val,
    then: Yup.string()
      .required('Debes ingresar RUT de beneficiario')
      .rut('El RUT es inválido'),
    otherwise: Yup.string().nullable()
  }),
  coverDetail: Yup.string().required('Debes ingresar un detalle de cobertura'),
  hiringPersonAddress: Yup.string().when('hiringPersonName', {
    is: val => !!val,
    then: Yup.string().required('Debes ingresar dirección del contratante'),
    otherwise: Yup.string().nullable()
  }),
  hiringPersonName: Yup.string().nullable(),
  hiringPersonNationalIdentification: Yup.string().when('hiringPersonName', {
    is: val => !!val,
    then: Yup.string()
      .required('Debes ingresar RUT del contratante')
      .rut('El RUT es inválido'),
    otherwise: Yup.string().nullable()
  }),
  insuredPersonAddress: Yup.string().required('Debes ingresar dirección comercial del asegurado'),
  insuredPersonName: Yup.string().required('Debes ingresar nombre y apellido del asegurado'),
  insuredPersonNationalIdentification: Yup.string()
    .required('Debes ingresar RUT del asegurado')
    .rut('El RUT es inválido')
};

export { commonValidation, requestQuotationValidation };
